import { useState } from 'react';
import { Check, Copy, MoreVertical } from 'lucide-react';
import { Button } from '@/components/ui/button';

type InviteSuccessProps = {
  inviteUrl: string;
  onFinish: () => void;
  title?: string;
  description?: string;
};

export const InviteSuccess = ({
  inviteUrl,
  onFinish,
  title = 'Usuário cadastrado com sucesso!',
  description = 'Copie o link de convite abaixo e envie para o usuário criar a senha de acesso.',
}: InviteSuccessProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(inviteUrl);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div className="flex flex-1 flex-col overflow-y-auto px-6 pt-8">
        <div className="mb-6 flex flex-col items-center text-center">
          <div className="mb-5 flex h-[72px] w-[72px] items-center justify-center rounded-full bg-[#E8FF47]">
            <Check className="h-8 w-8 text-black" strokeWidth={3} />
          </div>
          <h2 className="text-lg font-semibold leading-6 text-[#171717]">{title}</h2>
        </div>
        <p className="mb-4 text-center text-sm leading-5 text-[#525252]">{description}</p>
        <p className="mb-4 break-all text-center text-sm font-semibold leading-5 text-[#0F766E]">
          {inviteUrl}
        </p>
        <Button
          type="button"
          onClick={handleCopy}
          className="mb-6 h-9 w-full gap-2 rounded-lg border-0 bg-[#F5F5F5] px-4 py-2 text-sm font-medium leading-5 text-[#171717] shadow-[0px_1px_2px_rgba(0,0,0,0.05)] hover:bg-[#EBEBEB]"
        >
          <Copy className="h-4 w-4" />
          {copied ? 'Copiado' : 'Copiar'}
        </Button>
        <div className="space-y-3 border-t border-[#E5E5E5] pt-4 text-sm leading-5 text-[#525252]">
          <p>
            Este link expira em <span className="font-semibold text-[#171717]">7 dias</span>. Após
            esse prazo, será possível gerar um novo convite para este usuário.
          </p>
          <p>
            Não copiou agora? Sem problemas! O link também fica disponível a qualquer momento no menu
            de ações{' '}
            <MoreVertical className="mb-px inline h-4 w-4 align-text-bottom text-[#171717]" /> da
            lista de usuários.
          </p>
        </div>
      </div>
      <div className="shrink-0 border-t border-[#E5E5E5] px-6 py-4">
        <Button
          type="button"
          onClick={onFinish}
          className="h-9 w-full rounded-lg bg-[#171717] px-4 py-2 text-sm font-medium leading-5 text-[#FAFAFA] shadow-[0px_1px_2px_rgba(0,0,0,0.05)] hover:bg-[#171717]/90"
        >
          Concluir
        </Button>
      </div>
    </div>
  );
};
